import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, PropType, ref } from "vue";
import { TaskModel } from "@/components/tasks-kanban/models";
import { TaskParameterTypeEnum } from "@/components/task-parameter";
import TagParameter from "@/components/task-parameter/components/tag-parameter.vue";
import PriorityParameter from "@/components/task-parameter/components/priority-parameter.vue";
import StatusParameter from "@/components/task-parameter/components/status-parameter.vue";
import { OptionItemModel } from "../../../models";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPointsParameter',
  props: {
  /**Задача */
  item: { type: Object as PropType<OptionItemModel> },
  /**Тип */
  type: { type: Object as PropType<TaskParameterTypeEnum> },
},
  setup(__props) {

const props = __props;



/**Компонент для отображения параметра */
const parameterComponent = computed(() => {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      return StatusParameter;
    case TaskParameterTypeEnum.Priority:
      return PriorityParameter;
    case TaskParameterTypeEnum.Tag:
      return TagParameter;
  }
});

/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  if (!props.item.Width) props.item.Width = $itemFilter.value.offsetWidth;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$itemFilter",
    ref: $itemFilter
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(parameterComponent.value), {
      data: __props.item,
      hideRemove: "",
      preview: ""
    }, null, 8, ["data"]))
  ], 512))
}
}

})